import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    drawer: {
      [theme.breakpoints.up("md")]: {
        width: theme.drawer.width,
        flexShrink: 0,
      },
    },
    // necessary for content to be below app bar
    toolbar: {
      ...theme.mixins.toolbar,
      marginBottom: theme.spacing(1),
      display: "flex",
      justifyContent: "center",
      paddingTop: theme.spacing(1),
    },
    drawerPaper: {
      width: theme.drawer.width,
      padding: "0px 30px 100px",
      borderRight: "none",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  });
